import { forwardRef, memo } from 'react';
import type { ComponentPropsWithoutRef } from 'react';

import { cx } from '@/utils/cx';

import { useScrollContext } from '../HeaderContext';

import styles from './HeaderTitle.module.scss';

import type { VisibleOn } from '../types';

export interface HeaderTitleProps extends ComponentPropsWithoutRef<'div'> {
  /** 스크롤 시에만 표시 (CSS class 토글, DOM 항상 유지) */
  showOnScroll?: boolean;
  /** 특정 디바이스에서만 노출. 미지정 = 항상 노출 */
  visibleOn?: VisibleOn;
}

export const HeaderTitle = memo(
  forwardRef<HTMLDivElement, HeaderTitleProps>(({ children, className, visibleOn, showOnScroll, ...rest }, ref) => {
    const { isScrolled } = useScrollContext();
    const isHidden = showOnScroll && !isScrolled;

    return (
      <div
        aria-hidden={isHidden || undefined}
        className={cx(styles.title, isHidden && styles.hidden, className)}
        data-core-ui-header-slot="title"
        data-core-ui-visible-on={visibleOn}
        ref={ref}
        {...rest}
      >
        {children}
      </div>
    );
  }),
);

HeaderTitle.displayName = 'Header.Title';
